import { useContext } from 'react'
import '../../style/components/ticket.css'
import { context } from '../../context/context'
import { useTranslation } from 'react-i18next';
export default function Ticket(props) {
    const { t } = useTranslation();
    const { cart, setCart, setEdit } = useContext(context);
    const RemoveItem = () => {
        const remainsCart = [];
        cart.filter((item) => item.id !== props.id)
        .map((select) => remainsCart.push(select))
        setCart(remainsCart);
    }

    const editItem = () => {
        const product_change = cart.find((e) => e.id === props.id);
        setEdit(product_change);
    }
    const currency = props.currency;

    const HandlingDiscount = (type, value) => {
    if (!type || value <= 0) return null;
        return (
            <small>
                {type === "fixed"
                    ? `discount ${value} ${currency} per piece`
                    : `discount ${value}% per piece`}
            </small>
        );
    };

    return (
        <div className={`ticket flex flex flex-space-bet ${props.pointer?.id === props.id ? "select" : ""}`}>
            <div className='hidden'>{props.id}</div>
            <div onClick={() => editItem()} className="ticket-content">
                <h4 className='text-weight-light'>{props.title} - <span>{t("common:quantity")} {props.pieces}</span></h4>
                <p>{t("common:pos.total")} <span className='bold'>{props.total.toFixed(2)} {currency}</span>{HandlingDiscount(props.discount.discountType, props.discount.discountValue)}</p>
                <small className='left text-weight-bold'>#{props.barcode}</small>
            </div>
            <button onClick={()=>RemoveItem()} className='btnRemove error-bg'>x</button>
        </div>
    )
}